<div class="ondemand" (click)="handleClick()">
  <div class="ondemand__image" [lazyLoad]="getThumbnailUrl()"></div>
  
  <app-button-loader></app-button-loader>
  
  <div class="ondemand__logo">
    <img [src]="getPoweredByUrl()">
  </div>
</div>
